


//? environments
export const ENV = `${process.env.REACT_APP_ENVIRONMENT}`;
export const DEV_ENV = "development";
export const PROD_ENV = "production";



export const constants = () => {
  return {
    API_URL: `${process.env.REACT_APP_API_URL}`,
    TINYMCE_KEY: `${process.env.REACT_APP_TINYMCE_API_SECRET}`,
    MICROSOFT_CLARITY_ID: `${process.env.REACT_APP_MICROSOFT_CLARITY_ID}`,
  }
}